import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {DELETE_BLACKLISTED_CANDIDATE_URL} from '../../constants/apiUrls';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse, UuidModel} from '../typings';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void, reqData: UuidModel[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const useDeleteBlacklistedCandidate = ({onSuccess, onError, onSettled}: Input = {}) => {
  const deleteBlacklistedCandidate = async (reqBody: UuidModel[]) => {
    await axiosClient.delete(DELETE_BLACKLISTED_CANDIDATE_URL, {data: reqBody});
  };

  return useCustomMutation(deleteBlacklistedCandidate, {
    onSuccess,
    onError,
    onSettled,
  });
};
